import { render, staticRenderFns } from "./shipAddress.vue?vue&type=template&id=00bf8da7&"
import script from "./shipAddress.vue?vue&type=script&lang=js&"
export * from "./shipAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports